import ProductionDetailApp from "Production/Detail/app";
import { ProductionListApp } from "Production/List/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const productionRoute: RouteObject = {
  path: "production",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ProductionListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ProductionDetailApp,
  }]
};